/* ГОРОД N v10 — schema-first contracts (TypeBox). SSE draagt hints, geen inhoud. */
import { Type } from "@sinclair/typebox";
export * from './discovery.js';
export const Handle = Type.Union([Type.Literal("R"), Type.Literal("N")]);
export const Place = Type.Object({
    tz: Type.String(),
    ru: Type.String(),
    en: Type.String(),
});
export const Me = Type.Object({
    id: Type.String(),
    handle: Handle,
    displayName: Type.String(),
    tz: Type.String(),
    place: Place,
});
export const SignalKind = Type.Union([
    "answer", "photo", "line", "word", "smell", "audio", "doodle", "song",
].map(k => Type.Literal(k)));
export const PutEntryBody = Type.Object({
    text: Type.Optional(Type.String({ maxLength: 8000 })),
    attachmentId: Type.Optional(Type.String()),
    meta: Type.Optional(Type.Record(Type.String(), Type.Unknown())),
});
export const PhotoReactionEmoji = Type.Union([
    Type.Literal("❤️"), Type.Literal("🥰"), Type.Literal("😂"),
    Type.Literal("🥹"), Type.Literal("🔥"),
]);
export const PhotoReactionBody = Type.Object({ emoji: PhotoReactionEmoji });
export const EchoView = Type.Object({
    mine: Type.Boolean(),
    theirs: Type.Boolean(),
});
export const MoodKind = Type.Union([
    Type.Literal("calm"), Type.Literal("focused"), Type.Literal("soft"),
    Type.Literal("tired"), Type.Literal("low"), Type.Literal("stressed"),
    Type.Literal("excited"), Type.Literal("playful"),
]);
export const MoodBody = Type.Object({
    mood: MoodKind,
    note: Type.Optional(Type.String({ maxLength: 160 })),
});
export const MoodEntry = Type.Object({
    userId: Type.String(),
    handle: Handle,
    slotKey: Type.String(),
    mood: MoodKind,
    note: Type.Union([Type.String(), Type.Null()]),
    createdAt: Type.String(),
    updatedAt: Type.String(),
});
export const MoodSummary = Type.Object({
    me: Type.Union([MoodEntry, Type.Null()]),
    partner: Type.Union([MoodEntry, Type.Null()]),
    recent: Type.Array(MoodEntry),
});
export const RitualDayView = Type.Object({
    date: Type.String(),
    prompt: Type.Union([Type.Object({
            id: Type.String(), cat: Type.Union([Type.String(), Type.Null()]),
            original: Type.String(),
            textRu: Type.Union([Type.String(), Type.Null()]),
            textEn: Type.Union([Type.String(), Type.Null()]),
        }), Type.Null()]),
    sealedAt: Type.Union([Type.String(), Type.Null()]),
    revealedAt: Type.Union([Type.String(), Type.Null()]),
    mine: Type.Record(Type.String(), Type.Object({
        text: Type.Union([Type.String(), Type.Null()]),
        attachmentId: Type.Union([Type.String(), Type.Null()]),
    })),
    /* blind: van de ander alléén welke soorten er zijn — nooit inhoud vóór reveal */
    theirsKinds: Type.Array(SignalKind),
    theirs: Type.Union([Type.Record(Type.String(), Type.Object({
            text: Type.Union([Type.String(), Type.Null()]),
            attachmentId: Type.Union([Type.String(), Type.Null()]),
        })), Type.Null()]),
    photoReactions: Type.Object({
        /* mine = mijn sticker op hun foto; theirs = hun sticker op mijn foto. */
        mine: Type.Union([PhotoReactionEmoji, Type.Null()]),
        theirs: Type.Union([PhotoReactionEmoji, Type.Null()]),
    }),
    /* Alleen aanwezigheid, nooit echo-inhoud: de 10.47 MVP is één teken. */
    echoes: Type.Optional(EchoView),
    revision: Type.Integer(),
});
export const LetterBody = Type.Object({
    kind: Type.Union([Type.Literal("instant"), Type.Literal("card"), Type.Literal("window")]),
    deliveryMode: Type.Optional(Type.Union([
        Type.Literal("quick"), Type.Literal("medium"),
        Type.Literal("slow"), Type.Literal("random"),
    ])),
    body: Type.Optional(Type.String({ maxLength: 8000 })),
    stickers: Type.Optional(Type.Array(Type.String(), { maxItems: 3 })),
    winFrom: Type.Optional(Type.String({ pattern: "^\\d{4}-\\d{2}-\\d{2}$" })),
    winTo: Type.Optional(Type.String({ pattern: "^\\d{4}-\\d{2}-\\d{2}$" })),
    attachmentIds: Type.Optional(Type.Array(Type.String(), { maxItems: 2 })),
});
export const LetterView = Type.Object({
    id: Type.String(),
    author: Handle,
    kind: Type.String(),
    sendAt: Type.String(),
    deliveredAt: Type.Union([Type.String(), Type.Null()]),
    openedAt: Type.Union([Type.String(), Type.Null()]),
    /* inhoud alleen zichtbaar voor auteur of ná openen */
    body: Type.Union([Type.String(), Type.Null()]),
    stickers: Type.Union([Type.Array(Type.String()), Type.Null()]),
    attachmentIds: Type.Array(Type.String()),
    eta: Type.Union([Type.String(), Type.Null()]),
    progress: Type.Union([Type.Number(), Type.Null()]),
    deliveryMode: Type.Optional(Type.String()),
    etaRange: Type.Optional(Type.Union([Type.Object({
            from: Type.String(), to: Type.String(),
        }), Type.Null()])),
});
export const CityObjectView = Type.Object({
    id: Type.String(),
    date: Type.Union([Type.String(), Type.Null()]),
    kind: Type.String(),
    district: Type.Union([Type.String(), Type.Null()]),
    slot: Type.Union([Type.Integer(), Type.Null()]),
    geometry: Type.Record(Type.String(), Type.Unknown()),
    /* Afgeleid na reveal uit bestaande signalen; vóór reveal altijd leeg. */
    contributors: Type.Array(Handle),
    chapter: Type.Union([Type.Object({
            id: Type.String(), n: Type.Integer(), title: Type.String(),
            street: Type.Object({ R: Type.String(), N: Type.String() }),
        }), Type.Null()]),
}, { additionalProperties: false });
export const WorldPhaseView = Type.Object({
    id: Type.String(), chapterId: Type.String(), key: Type.String(),
    title: Type.String(), kind: Type.String(), placeCode: Type.Union([Type.String(), Type.Null()]),
    startsOn: Type.String(), endsOn: Type.Union([Type.String(), Type.Null()]),
    paletteKey: Type.String(), order: Type.Integer(),
});
export const WorldMemoryUnitView = Type.Object({
    id: Type.String(), date: Type.String(), unitIndex: Type.Integer(),
    contributors: Type.Array(Handle), kinds: Type.Array(SignalKind),
});
export const WorldProjectView = Type.Object({
    id: Type.String(), phaseId: Type.String(), sequence: Type.Integer(),
    kind: Type.String(), title: Type.String(), state: Type.Union([
        Type.Literal("active"), Type.Literal("completed"),
    ]), targetUnits: Type.Integer(), completedUnits: Type.Integer(),
    stage: Type.String(), x: Type.Number(), z: Type.Number(), rotation: Type.Number(),
    units: Type.Array(WorldMemoryUnitView), specialReason: Type.Union([Type.String(), Type.Null()]),
});
export const WorldLandmarkView = Type.Object({
    id: Type.String(), key: Type.String(), title: Type.String(),
    route: Type.String(), x: Type.Number(), z: Type.Number(),
    kind: Type.String(),
});
export const WorldEventView = Type.Object({
    id: Type.String(), kind: Type.String(), title: Type.String(),
    date: Type.Union([Type.String(), Type.Null()]),
});
export const WorldManifest = Type.Object({
    version: Type.Integer(), layoutVersion: Type.Integer(), generatedAt: Type.String(),
    chapters: Type.Array(Type.Object({
        id: Type.String(), n: Type.Integer(), title: Type.String(), state: Type.String(),
    })),
    phases: Type.Array(WorldPhaseView), projects: Type.Array(WorldProjectView),
    landmarks: Type.Array(WorldLandmarkView), events: Type.Array(WorldEventView),
    bounds: Type.Object({ minX: Type.Number(), maxX: Type.Number(), minZ: Type.Number(), maxZ: Type.Number() }),
    active: Type.Object({ chapterId: Type.String(), phaseId: Type.String(),
        projectId: Type.Union([Type.String(), Type.Null()]),
        todayUnitId: Type.Union([Type.String(), Type.Null()]) }),
});
export const LivingScene = Type.Object({
    sceneId: Type.String(),
    phase: Type.Union([
        Type.Literal("quiet"), Type.Literal("opening"), Type.Literal("together"),
        Type.Literal("growth"), Type.Literal("arrival"), Type.Literal("afterglow"),
    ]),
    accent: Type.Union([
        Type.Literal("gold"), Type.Literal("violet"), Type.Literal("blue"),
        Type.Literal("green"), Type.Literal("rose"),
    ]),
    headline: Type.Object({ en: Type.String(), ru: Type.String() }),
    subline: Type.Object({ en: Type.String(), ru: Type.String() }),
    primaryAction: Type.Object({ en: Type.String(), ru: Type.String(), href: Type.String() }),
    beats: Type.Array(Type.Object({
        type: Type.Union([
            Type.Literal("mood"), Type.Literal("ritual"), Type.Literal("game"),
            Type.Literal("garden"), Type.Literal("letter"), Type.Literal("journey"),
        ]),
        time: Type.Union([Type.String(), Type.Null()]),
        href: Type.String(),
        label: Type.Object({ en: Type.String(), ru: Type.String() }),
    })),
});
export const Bootstrap = Type.Object({
    me: Me,
    partner: Me,
    chapter: Type.Object({
        n: Type.Integer(), title: Type.String(), state: Type.String(),
        meetAt: Type.Union([Type.String(), Type.Null()]),
        tripEnd: Type.Union([Type.String(), Type.Null()]),
        tentativeStart: Type.Union([Type.String(), Type.Null()]),
        nextKeyR: Type.Union([Type.String(), Type.Null()]),
        nextKeyN: Type.Union([Type.String(), Type.Null()]),
        nextTitle: Type.Union([Type.String(), Type.Null()]),
    }),
    today: RitualDayView,
    together: Type.Object({
        together: Type.Boolean(),
        place: Type.Union([Type.Object({
                code: Type.String(), tz: Type.String(), ru: Type.String(), en: Type.String(),
            }), Type.Null()]),
    }),
    sharedScene: LivingScene,
    mood: Type.Optional(MoodSummary),
    care: Type.Optional(Type.Object({
        me: Type.Object({ date: Type.String(), water: Type.Integer(), meals: Type.Integer(),
            updatedAt: Type.Union([Type.String(), Type.Null()]) }),
        partner: Type.Object({ date: Type.String(), water: Type.Integer(), meals: Type.Integer(),
            updatedAt: Type.Union([Type.String(), Type.Null()]) }),
    })),
    city: Type.Array(CityObjectView),
    post: Type.Object({
        traveling: Type.Array(Type.Object({
            id: Type.String(), author: Handle,
            eta: Type.Union([Type.String(), Type.Null()]), progress: Type.Number(),
        })),
        unopened: Type.Integer(),
    }),
    garden: Type.Optional(Type.Object({
        daysBuilt: Type.Integer(), lettersDelivered: Type.Integer(),
        capsulesSealed: Type.Integer(), capsulesOpened: Type.Integer(),
        songsShared: Type.Integer(), sharedSparks: Type.Optional(Type.Integer()),
        gamesFinished: Type.Optional(Type.Integer()), gamesOpen: Type.Optional(Type.Integer()),
        chapters: Type.Integer(),
    })),
    /* Fotodagen als stadsmetadata — begrensd, zonder media-id's; vóór de
       reveal alleen de eigen bijdrage van de lezer. */
    photoArtifacts: Type.Optional(Type.Array(Type.Object({
        date: Type.String(),
        state: Type.Union([Type.Literal("solo"), Type.Literal("together")]),
        contributors: Type.Array(Handle),
        museumTarget: Type.String(),
    }))),
    presence: Type.Record(Type.String(), Type.Boolean()),
    weather: Type.Union([Type.Record(Type.String(), Type.Unknown()), Type.Null()]),
    pushKey: Type.Union([Type.String(), Type.Null()]),
    lastEventSeq: Type.Integer(),
}, { additionalProperties: false });
export const Problem = Type.Object({
    type: Type.String(),
    title: Type.String(),
    status: Type.Integer(),
    detail: Type.Optional(Type.String()),
});
/* SSE-eventtypes (v1) — payload bevat uitsluitend id's/hints */
export const EventTypes = [
    "signal.recorded.v1", "ritual.revealed.v1", "ritual.sealed.v1",
    "city.built.v1", "letter.sent.v1", "letter.delivered.v1", "letter.opened.v1",
    "capsule.sealed.v1", "capsule.opened.v1", "chapter.transitioned.v1",
    "weather.updated.v1", "ogonek.v1", "chapter.trip.set.v1",
    "planner.command.applied.v1", "recap.published.v1",
    "quest.proposed.v1", "quest.chosen.v1", "quest.completed.v1",
    "radio.track.added.v1", "radio.track.deleted.v1", "radio.broadcast.published.v1",
    "game.started.v1", "game.moved.v1", "game.finished.v1",
    "same-street.spark.v1", "samesky.star.v1", "photo.reacted.v1", "echo.left.v1",
    "mood.updated.v1", "care.updated.v1", "home.updated.v1", "garden.updated.v1", "nightpost.updated.v1", "city-history.updated.v1",
];
export * from "./home.js";
export * from "./garden.js";
export * from "./nightpost.js";
export * from "./cityHistory.js";
export * from './living.js';
export * from './interior.js';
export * from "./murdoku.js";
export * from "./weather.js";
/* Het weer van afgesloten dagen, per plek: metingen, geen labels. Bewust een eigen
   endpoint en NIET in de bootstrap: de client valideert de bootstrap met
   `additionalProperties: false`, dus een extra veld daar breekt elke bundel die
   al live staat ("City data is temporarily unavailable"). Een eigen endpoint is
   puur additief: oude bundels kennen het niet en merken niets. */
export const DayWeatherResponse = Type.Object({
    days: Type.Record(Type.String(), Type.Record(Type.String(), Type.Object({
        v: Type.Literal(1), cover: Type.Number(), mm: Type.Number(), wetHours: Type.Integer(),
        peakMm: Type.Number(), snowCm: Type.Number(), tMin: Type.Number(), tMax: Type.Number(),
        fog: Type.Boolean(), storm: Type.Boolean(), sunHours: Type.Integer(), hours: Type.Integer(),
    }))),
}, { additionalProperties: false });
//# sourceMappingURL=index.js.map